import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';

const DetailsPanel = ({ children, title, mdSize, allowFullyPaidFunds, offset }) => (
  <Col xs={12} md={mdSize} mdOffset={offset}>
    {title && (
      <h4 className={styles.title}>
        {title}
        {allowFullyPaidFunds && (
          <Badge className={styles.badgeColor}>
            <FormattedMessage {...messages.fullyPaidUnsettledFunds} />
          </Badge>
        )}
      </h4>
    )}
    {children}
  </Col>
);

DetailsPanel.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  mdSize: PropTypes.number,
  allowFullyPaidFunds: PropTypes.bool,
  offset: PropTypes.number,
};

DetailsPanel.defaultProps = {
  children: null,
  title: null,
  mdSize: 6,
  allowFullyPaidFunds: false,
  offset: null,
};

export default DetailsPanel;



// WEBPACK FOOTER //
// ./src/components/DetailsPanel/index.js